import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { AnnouncementPublishingStatusEnum } from "@saleor/types/globalTypes";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum AnnouncementFilterKeys {
  started = "started",
  status = "status"
}

export interface AnnouncementListUrlFiltersOpts {
  started: FilterOpts<MinMax>;
  status: FilterOpts<AnnouncementPublishingStatusEnum>;
}

export enum AnnouncementVisibility {
  PUBLISHED = "published",
  UNPUBLISHED = "unpublished"
}

const messages = defineMessages({
  published: {
    defaultMessage: "Published",
    description: "Published Status"
  },
  started: {
    defaultMessage: "Date Range",
    description: "voucher start date"
  },
  status: {
    defaultMessage: "Status",
    description: "Status"
  },
  unpublished: {
    defaultMessage: "Unpublished",
    description: "Unpublished Status"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: AnnouncementListUrlFiltersOpts
): IFilter<AnnouncementFilterKeys> {
  return [
    {
      ...createDateField(
        AnnouncementFilterKeys.started,
        intl.formatMessage(messages.started),
        opts.started.value
      ),
      active: opts.started.active
    },
    {
      ...createOptionsField(
        AnnouncementFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        [
          {
            label: intl.formatMessage(messages.published),
            value: AnnouncementPublishingStatusEnum.PUBLISHED
          },
          {
            label: intl.formatMessage(messages.unpublished),
            value: AnnouncementPublishingStatusEnum.UNPUBLISHED
          }
        ]
      ),
      active: opts.status.active
    }
  ];
}
